module.exports = __webpack_public_path__ + "img/paymentMethod.fef859fb.png";